import React from 'react';
import { motion } from 'framer-motion';
export const Privacy = () => {
  return <main className="pt-32 pb-24 bg-brand-warm-white min-h-screen" data-id="element-447">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto px-6" data-id="element-448">
        <div className="mb-16" data-id="element-449">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-450">
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-display text-brand-navy mb-6" data-id="element-451">
            Privacy Policy
          </h1>
          <p className="text-brand-charcoal/60" data-id="element-452">Last updated: July 14, 2026</p>
        </div>

        <div className="space-y-12 text-brand-charcoal/80 leading-relaxed bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-brand-navy/5" data-id="element-453">
          <section data-id="element-454">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-455">
              1. Introduction
            </h2>
            <p className="mb-4" data-id="element-456">
              Consilium Advisory ("we," "our," or "us") respects your privacy
              and is committed to protecting your personal data. This privacy
              policy will inform you as to how we look after your personal data
              when you visit our website and tell you about your privacy rights
              and how the law protects you.
            </p>
          </section>

          <section data-id="element-457">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-458">
              2. The Data We Collect
            </h2>
            <p className="mb-4" data-id="element-459">
              We may collect, use, store and transfer different kinds of
              personal data about you which we have grouped together as follows:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-brand-charcoal/70" data-id="element-460">
              <li data-id="element-461">
                <strong data-id="element-462">Identity Data</strong> includes first name, last name,
                username or similar identifier.
              </li>
              <li data-id="element-463">
                <strong data-id="element-464">Contact Data</strong> includes email address and
                telephone numbers.
              </li>
              <li data-id="element-465">
                <strong data-id="element-466">Technical Data</strong> includes internet protocol (IP)
                address, your login data, browser type and version, time zone
                setting and location.
              </li>
              <li data-id="element-467">
                <strong data-id="element-468">Usage Data</strong> includes information about how you
                use our website, products and services.
              </li>
            </ul>
          </section>

          <section data-id="element-469">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-470">
              3. How We Use Your Data
            </h2>
            <p className="mb-4" data-id="element-471">
              We will only use your personal data when the law allows us to.
              Most commonly, we will use your personal data in the following
              circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-brand-charcoal/70" data-id="element-472">
              <li data-id="element-473">
                Where we need to perform the contract we are about to enter into
                or have entered into with you.
              </li>
              <li data-id="element-474">
                Where it is necessary for our legitimate interests (or those of
                a third party) and your interests and fundamental rights do not
                override those interests.
              </li>
              <li data-id="element-475">Where we need to comply with a legal obligation.</li>
            </ul>
          </section>

          <section data-id="element-476">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-477">
              4. Data Security
            </h2>
            <p className="mb-4" data-id="element-478">
              We have put in place appropriate security measures to prevent your
              personal data from being accidentally lost, used or accessed in an
              unauthorized way, altered or disclosed. In addition, we limit
              access to your personal data to those employees, agents,
              contractors and other third parties who have a business need to
              know.
            </p>
          </section>

          <section data-id="element-479">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-480">
              5. Contact Us
            </h2>
            <p className="mb-4" data-id="element-481">
              If you have any questions about this privacy policy or our privacy
              practices, please contact us at:
            </p>
            <p className="font-medium text-brand-navy" data-id="element-482">
              Emmanuel@consiliumadvisory.com
              <br data-id="element-483" />
              240-882-3949
            </p>
          </section>
        </div>
      </motion.div>
    </main>;
};